module.exports = __webpack_public_path__ + "static/media/stade.60ad9b02.jpg";